import {
  ArticleHeading2,
  ArticleHeading3,
  ArticleParagraph1,
  ArticleParagraph3,
  Image,
  ModalWindow,
} from '@cian/ui-kit';

import { FC } from 'react';

import { formatPhoneNumber } from '../../utils/formatPhoneNumber';

import { IContactModal } from './types';

import * as styles from './styles.css';

export const ContactModal: FC<IContactModal> = props => {
  const { operator, accessInfo, onClose } = props;

  if (!operator) {
    return null;
  }

  const { phone, companyName, logo } = operator;

  return (
    <ModalWindow escape open outside height={246} width={448} onClose={onClose}>
      <div className={styles['root']}>
        <ArticleHeading3>Контакты оператора коворкинга</ArticleHeading3>
        <div className={styles['phone']}>
          <ArticleHeading2>{formatPhoneNumber(phone)}</ArticleHeading2>
        </div>
        <div className={styles['about']}>
          <div className={styles['operator']}>
            <ArticleParagraph3 color="gray60_100">Оператор коворкингов</ArticleParagraph3>
            <ArticleParagraph1 fontWeight="bold">{companyName}</ArticleParagraph1>
            <ArticleParagraph3>{accessInfo}</ArticleParagraph3>
          </div>
          <div className={styles['logo']}>
            <Image height={40} src={logo} width={40} />
          </div>
        </div>
      </div>
    </ModalWindow>
  );
};

ContactModal.displayName = 'ContactModal';
